export const reviewPageEN = {
	eyebrow: "Your feedback",
	title: "Leave a Review",
	editTitle: "Edit your review",
	ask: "How was your visit?",
	// Index 0 is the prompt shown before anything is picked.
	ratings: ["Click to rate", "Terrible", "Poor", "Okay", "Great", "Excellent"],
	placeholder: "Share your experience...",
	anonymous: "Leave this review anonymously",
	submit: "Submit Review",
	save: "Save changes",
	submitting: "Submitting...",
	back: "Back",
	editHint: "You've already reviewed this booking. Updating it replaces what you wrote before.",
	errorNoRating: "Please choose a rating before continuing.",
	errorSubmit: "We couldn't submit your review. Please try again.",
	errorLoad: "We couldn't load this booking, so there's nothing to review yet. Please try again.",
	commentLabel: "Add a comment (optional)",
};
